export const messages = {
  en: {
    urgentPurchaseApplyStep: {
      applyInfo: 'Application Information',
      warehouse: 'Warehouse',
      requiredSelectWarehouse: 'Required, please select warehouse',
      contact: 'Contact',
      requiredContact: 'Required, please fill in contact',
      phone: 'Phone',
      requiredPhone: 'Required, please fill in phone number',
      applyDesc: 'Application Description',
      requiredDesc: 'Required, please fill in application description',
      purchaseItems: 'Purchase Items',
      select: 'Select',
      itemType: 'Item Type',
      nameCode: 'Name(Code)',
      spec: 'Specification',
      referencePrice: 'Reference Price',
      stock: 'Stock',
      applyQuantity: 'Apply Quantity',
      requiredQuantity: 'Required, please fill in quantity',
      purchasePrice: 'Purchase Price',
      requiredPrice: 'Required, please fill in price',
      targetWarehouse: 'Target Warehouse',
      requiredTargetWarehouse: 'Required, please select target warehouse',
      remark: 'Remark',
      optionalRemark: 'Optional, please fill in remark',
      operation: 'Operation',
      remove: 'Remove',
      submit: 'Submit',
      requiredSelectItems: 'Please select purchase items',
      sameWarehouseRequired: 'Purchased items must come from the same warehouse!'
    },
    chooseResourceStore4: {
      title: '[Urgent Purchase] Select Items',
      selectWarehouse: 'Please select warehouse',
      selectItemType: 'Please select item type',
      selectSubType: 'Please select sub category',
      inputItemName: 'Input item name',
      warehouse: 'Warehouse',
      itemType: 'Item Type',
      itemName: 'Item Name',
      spec: 'Specification',
      code: 'Code',
      fixedItem: 'Fixed Item',
      price: 'Price',
      stock: 'Stock',
      selectItemsRequired: 'Please select items to purchase'
    }
  },
  zh: {
    urgentPurchaseApplyStep: {
      applyInfo: '申请信息',
      warehouse: '仓库',
      requiredSelectWarehouse: '必填，请选择仓库',
      contact: '联系人',
      requiredContact: '必填，请填写联系人',
      phone: '联系电话',
      requiredPhone: '必填，请填写联系电话',
      applyDesc: '申请说明',
      requiredDesc: '必填，请填写申请说明',
      purchaseItems: '采购物品',
      select: '选择',
      itemType: '物品类型',
      nameCode: '名称(编码)',
      spec: '物品规格',
      referencePrice: '参考价格',
      stock: '物品库存',
      applyQuantity: '申请数量',
      requiredQuantity: '必填，请填写申请数量',
      purchasePrice: '采购单价',
      requiredPrice: '必填，请填写采购单价',
      targetWarehouse: '目标仓库',
      requiredTargetWarehouse: '必填，请选择目标仓库',
      remark: '备注',
      optionalRemark: '选填，请填写备注',
      operation: '操作',
      remove: '移除',
      submit: '提交',
      requiredSelectItems: '请选择采购物品',
      sameWarehouseRequired: '采购商品需来自同一仓库！'
    },
    chooseResourceStore4: {
      title: '【紧急采购】选择物品',
      selectWarehouse: '请选择仓库',
      selectItemType: '请选择物品类型',
      selectSubType: '请选择二级分类',
      inputItemName: '输入物品管理名称',
      warehouse: '仓库',
      itemType: '物品类型',
      itemName: '物品名称',
      spec: '物品规格',
      code: '物品编码',
      fixedItem: '固定物品',
      price: '物品价格',
      stock: '物品库存',
selectItemsRequired: '请选择需要采购的物品'
    }
  },
  'zh-TW': {
    urgentPurchaseApplyStep: {
      applyInfo: '申請信息',
      warehouse: '倉庫',
      requiredSelectWarehouse: '必填，請選擇倉庫',
      contact: '聯繫人',
      requiredContact: '必填，請填寫聯繫人',
      phone: '聯繫電話',
      requiredPhone: '必填，請填寫聯繫電話',
      applyDesc: '申請說明',
      requiredDesc: '必填，請填寫申請說明',
      purchaseItems: '採購物品',
      select: '選擇',
      itemType: '物品類型',
      nameCode: '名稱(編碼)',
      spec: '物品規格',
      referencePrice: '參考價格',
      stock: '物品庫存',
      applyQuantity: '申請數量',
      requiredQuantity: '必填，請填寫申請數量',
      purchasePrice: '採購單價',
      requiredPrice: '必填，請填寫採購單價',
      targetWarehouse: '目標倉庫',
      requiredTargetWarehouse: '必填，請選擇目標倉庫',
      remark: '備註',
      optionalRemark: '選填，請填寫備註',
      operation: '操作',
      remove: '移除',
      submit: '提交',
      requiredSelectItems: '請選擇採購物品',
      sameWarehouseRequired: '採購商品需來自同一倉庫！'
    },
    chooseResourceStore4: {
      title: '【緊急採購】選擇物品',
      selectWarehouse: '請選擇倉庫',
      selectItemType: '請選擇物品類型',
      selectSubType: '請選擇二級分類',
      inputItemName: '輸入物品管理名稱',
      warehouse: '倉庫',
      itemType: '物品類型',
      itemName: '物品名稱',
      spec: '物品規格',
      code: '物品編碼',
      fixedItem: '固定物品',
      price: '物品價格',
      stock: '物品庫存',
      selectItemsRequired: '請選擇需要採購的物品'
    }
  }
}